import React, { FC } from 'react';
import { registerFonts } from '../../badge/pdf/pdfDocument/pdfStyles';
import moment from 'moment';
import { getFieldWithEnding } from './utils';
import { Document, Image, Page, StyleSheet, Text, View, Link } from '@react-pdf/renderer';
import { FONT, PAPER_SIZE } from '../../types/enums';
import PDFUtils from '../../badge/utils/pdfUtils';
import { VisaDocumentProps } from '../types';
import { useVisaDocumentFR } from './hooks/useVisaDocumentFR';
import { TextWithFontCheck as TFC } from '../../common/components/textWithFontCheck/TextWithFontCheck';

const styles = StyleSheet.create({
  container: {
    fontSize: '11px',
    fontFamily: FONT.HELVETICA,
    paddingLeft: '3cm',
    paddingRight: '3cm',
    paddingBottom: '.5cm'
  },
  bold: {
    fontFamily: FONT.HELVETICA_BOLD
  },
  footer: {
    minWidth: '596px',
    maxWidth: '596px',
    minHeight: '172px',
    maxHeight: '172px',
    marginTop: 'auto'
  },
  logo: {
    minWidth: '596px',
    maxWidth: '596px',
    minHeight: '86px',
    maxHeight: '86px',
    marginBottom: '10px'
  },
  alignLeft: {
    textAlign: 'right'
  },
  mb10: {
    marginBottom: '10px'
  },
  mb20: {
    marginBottom: '20px'
  }
});

export const VisaDocumentENGBVisitor: FC<VisaDocumentProps> = ({
                                                                 event, logoSrc, footerSrc, person, company
                                                               }) => {
  registerFonts();
  moment.locale('en');
  const { startDate, endDate } = useVisaDocumentFR(event.dates);

  const eventState = getFieldWithEnding(event.state, ', ');
  const eventCity = getFieldWithEnding(event.city, ', ');
  const eventCountry = getFieldWithEnding(event.country);

  return <Document>
    <Page size={PAPER_SIZE.A4}>
      <Image style={styles.logo} src={PDFUtils.returnSrc(logoSrc)} />
      <View style={styles.container}>
        <Text style={[styles.alignLeft, styles.mb10, styles.bold]}>VISITOR</Text>
        <Text style={styles.mb10}>{moment().format('DD MMM YYYY')}</Text>
        <TFC>{person.passportData.name}</TFC>
        <TFC>{person.position}</TFC>
        <TFC>{company.address1}</TFC>
        {(company.address2 && <TFC>{company.address2}</TFC>) || null}
        <TFC style={styles.mb20}>{company.postCode}</TFC>
        <Text style={styles.bold}>Visa Application for: <TFC bold>{person.passportData.name}</TFC></Text>
        <Text style={styles.bold}>Passport Number: <TFC bold>{person.passportData.passportNumber}</TFC></Text>
        <Text style={[styles.mb10, styles.bold]}>Nationality: <TFC bold>{person.passportData.country}</TFC></Text>
        <Text style={styles.mb10}>Dear Sir/Madam:</Text>
        <Text style={styles.mb10}>You have expressed interest in attending <TFC
          bold>{event.name}</TFC> (the
          <Text style={styles.bold}>“Event”</Text>), which is organised by Reed
          Exhibitions Limited (<Text style={styles.bold}>“RX”</Text>) in the {event.country}. RX, the world’s leading organiser of
          trade and consumer
          exhibitions, together with its affiliates, runs over 500 events in almost 30 countries, attracting
          more than 7,000,000 participants. Your attendance at the Event would be as a visitor to the Event.
          The Event is scheduled to be held at <TFC bold>{event.venue}</TFC> in <TFC
            bold>
            {`${eventCity}${eventState}${eventCountry}`}
          </TFC>,
          on <Text style={styles.bold}>{startDate} - {endDate}</Text>.</Text>
        <Text style={styles.mb10}>You will be solely responsible for paying for all costs of your trip (plane, hotel,
          etc.). RX
          provides no financial guarantee in respect of your return to your country of origin.</Text>
        <Text style={styles.mb10}>Please note that while RX would like you to attend <TFC
          bold>{event.name}</TFC>, it is in the sole
          discretion of the{' '}
          {event.country} immigration authorities to determine whether or not to issue you with a visa to enter the {event.country}.
          This letter is being issued to you on the basis that you agree (i) that you will not carry out any
          activities in breach of your conditions of stay during this trip and (ii) that any visa obtained by
          you on the basis of this letter shall be solely for the purpose of the Event and shall not be used for
          other visits to the {event.country}.</Text>
        {/*Keep commented until event emails are not configured. Details in MER-7742.*/}
        <Text style={styles.mb10}>{/*If you have any questions, you can contact RX by email at <TFC
          bold>{event.email}</TFC>.*/} For
          more
          information on the Event, please access the official website at <Link style={styles.bold}
                                                                                src={event.websiteUrl}><TFC bold>{event.websiteUrl}</TFC></Link>.</Text>
        <Text style={styles.mb20}>Yours Sincerely,</Text>
      </View>
      <Image style={styles.footer} src={PDFUtils.returnSrc(footerSrc)} />
    </Page>
  </Document>;
};
